import { searchExternalPlaces } from 'api/external-search'
import { MapQueryParams, UnreportedPlaceCandidate } from 'infra/type'

export const crawlKakao = async (
  queryParams: MapQueryParams,
): Promise<UnreportedPlaceCandidate[]> =>
  searchExternalPlaces('kakao', queryParams)
